import React from "react";
import Login from "../../Components/Front-End/Login/Login";

const LoginPage = () => {
  return (
    <Login/>
  );
};

export default LoginPage;